/**
 * StatRow - Mobile
 * 
 * Horizontal stat columns for overview sections.
 * Clean, ledger-like presentation.
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { color, text, space, radius, border } from '../../../shared/tokens/mobile';

interface Stat {
  value: string;
  label: string;
}

interface StatRowProps {
  stats: Stat[];
}

export function StatRow({ stats }: StatRowProps) {
  return (
    <View style={styles.container}>
      {stats.map((stat, index) => (
        <View 
          key={index} 
          style={[
            styles.column,
            index < stats.length - 1 && styles.columnBorder,
          ]}
        >
          <Text style={styles.value}>{stat.value}</Text>
          <Text style={styles.label}>{stat.label}</Text>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: color.surface,
    borderRadius: radius.md,
    borderWidth: border.width.thin,
    borderColor: color.border,
    paddingVertical: space.md + space.xs,
  },
  column: {
    flex: 1,
    alignItems: 'center',
  },
  columnBorder: {
    borderRightWidth: 1,
    borderRightColor: color.divider,
  },
  value: {
    fontSize: text.statValue.fontSize,
    fontWeight: text.statValue.fontWeight,
    lineHeight: text.statValue.lineHeight,
    letterSpacing: text.statValue.letterSpacing,
    color: color.textPrimary,
  },
  label: {
    fontSize: text.caption.fontSize,
    fontWeight: text.caption.fontWeight,
    color: color.textSecondary,
    marginTop: space.xs,
  },
});
